module.exports = "/_next/static/images/nj-e70ac2fa2d9290b369efce03d5a163ee.png.webp";